<template>
  <div>
    <!-- Pagina 1 -->
    <div style="width: 100%; text-align: center; float: left">
      <img
        src="data:image/jpeg;base64,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"
        height="100px"
        width="100px"
      />
    </div>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <div style="width: 50%; float: left">
        <p>
          <b>{{ clienteNombreCompleto }}</b
          ><br />
          {{ datos.cliente && datos.cliente.contacto.direccion }}<br />
          {{ datos.cliente.contacto.cp }} - {{ datos.cliente.contacto.localidad.provincia.nombre }}
        </p>
        <p>
          <b>A/A: {{ clienteNombreCompleto }}</b>
        </p>
      </div>
      <div style="width: 50%; float: left; font-size: 0.8rem">
        <table
          style="margin-right: 0; margin-left: auto; width: 70%; padding: 2px"
        >
          <tbody>
            <tr>
              <td colspan="2" style="text-align: center">
                REGISTRO DOCUMENTOS
              </td>
            </tr>
            <tr style="text-align: left">
              <td><input type="checkbox" /> ENTRADA</td>
              <td><input type="checkbox" /> SALIDA</td>
            </tr>
            <tr style="text-align: left">
              <td colspan="2">N REGISTRO: {{ datos.codigo }}</td>
            </tr>
            <tr style="text-align: left">
              <td>FECHA: {{ formatDate(datos.created_at) }}</td>
              <td><input type="checkbox" /> ANEJOS</td>
            </tr>
            <tr style="text-align: left">
              <td colspan="2">ARCHIVO:</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="clear: both"></div>
    </div>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        text-align: right;
      "
    >
      <span style="font-style: italic">
        {{ formatDateLong(datos.created_at) }}
      </span>
    </p>

    <p style="width: 80%; margin-left: auto; margin-right: auto">
      <strong
        >ASUNTO: Asignaci&oacute;n n&uacute;mero de Expediente de
        Certificaci&oacute;n.</strong
      >
    </p>

    <p style="width: 80%; margin-left: auto; margin-right: auto">
      Estimado Sr.:
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
      "
    >
      Conforme a nuestro Procedimiento de Certificación y a los documentos
      normativos que aplican al mismo, (RD 4/2014 y Protocolo de Actuación en su
      edición vigente), procedemos a recordarle los siguientes aspectos a tener
      en cuenta respecto del expediente de certificación que recientemente ha
      iniciado su empresa:
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
      "
    >
      1º.- Con fecha {{ formatDate(datos.created_at) }} y registro de entrada en
      CERTICAR SL Nº 0564, se recibió la Solicitud Formal de Certificación por
      parte de su empresa, para la certificación de producto conforme al RD
      4/2014, de 10 de enero de 2014, por el que se aprueba la Norma de calidad
      para la carne, el jamón, la paleta y la caña de lomo ibérico, que su
      empresa comercializará.
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
      "
    >
      2º.- Que los datos contenidos en la Solicitud de Certificación identifican
      el establecimiento solicitante con los siguientes datos:
    </p>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <table style="width: 100%; padding: 6px 3px">
        <tbody>
          <tr>
            <td style="width: 33%">
              <b>Razón Social del<br />solicitante:</b>
            </td>
            <td>
              <b
                ><u>{{ clienteNombreCompleto }}</u></b
              >
            </td>
          </tr>
          <tr>
            <td><b>Domicilio social:</b></td>
            <td>
              {{ datos.cliente && datos.cliente.contacto.direccion }}<br />
              {{ datos.cliente.cp }} - {{ datos.cliente.contacto.localidad.provincia.nombre }}
            </td>
          </tr>
          <tr>
            <td><b>Domicilio industrial:</b></td>
            <td>
              {{ datos.cliente && datos.cliente.direccion }}<br />
              {{ datos.cliente.contacto.cp }} - {{ datos.cliente.contacto.localidad.provincia.nombre
              }}<br />
              <b>Nº RGSEAA: {{ rgseaa() }}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
        margin-top: 10px;
      "
    >
      3º.- Que CERTICAR SL procede a asignarle un Número de Expediente para
      iniciar el proceso de certificación de producto, y que se mantendrá a lo
      largo de toda su vinculación con CERTICAR SL para este esquema de
      certificación y deberá estar reflejado en el Etiquetado de los Productos
      Certificados:
    </p>

    <p style="width: 80%; margin-left: auto; margin-right: auto">
      En su caso este número de expediente que se le asigna es el siguiente:
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        border: 1px solid black;
      "
    >
      <strong>NÚMERO DE EXPEDIENTE: {{ datos.codigo }}</strong>
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
      "
    >
      4º El presente escrito NO ES VALIDO para la solicitud de precintos de la
      norma de calidad asignados por ASICI. Si su empresa va a realizar o
      subcontratar actividades que requieran la petición de precintos de la
      norma de calidad a ASICI, por favor contacte con CERTICAR S.L. y les
      facilitaremos el documento necesario para la solicitud de los mismos.
    </p>

    <!-- Pagina 2 -->
    <div class="page-break-before"></div>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        text-align: justify;
      "
    >
      5º.- La fijación de la fecha de auditoría entre el suministrador y
      CERTICAR S.L. es requisito imprescindible si necesitan que CERTICAR S.L.
      emita el documento que les permita solicitar los precintos de la norma de
      calidad asignados por parte de ASICI.
    </p>

    <p style="width: 80%; margin-left: auto; margin-right: auto">
      Quedamos a su disposición para cualquier aclaración que precise.
    </p>

    <p style="width: 80%; margin-left: auto; margin-right: auto">
      Atentamente,
    </p>

    <p
      style="
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        text-align: right;
      "
    >
      Sonia Domingo<br />
      Departamento de Calidad
    </p>

    <div
      class="footer"
      style="
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        font-size: 11px;
        border-top: 1px solid black;
      "
    >
      <p style="font-family: serif; text-align: center">
        CERTICAR, S.L. Plaza Carlos Trías Bertrán, Nº 4 – 1 planta – 28.020 –
        MADRID<br />
        e.mail: certicar@certicar.es
      </p>
    </div>
  </div>
</template>

<style scoped>
table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 0.5px solid black;
}

@media print {
  div.footer {
    margin-top: 10px;
    position: fixed;
    bottom: 0;
  }

  div.footer p {
    text-align: center;
  }
}
</style>

<script>
import MODELS from "~/models/kaam/solicitudes";

export default {
  props: {
    datos: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    tipoProducto: MODELS.PRODUCTO_TIPO,
  }),
  computed: {
    clienteNombreCompleto() {
      let nombre = "";
      const cliente = this.datos.cliente;
      if (cliente) {
        if (cliente.nombre) nombre += cliente.nombre;
        if (cliente.primer_apellido) nombre += " " + cliente.primer_apellido;
        if (cliente.segundo_apellido) nombre += " " + cliente.segundo_apellido;
      }
      return nombre;
    }
  },
  methods: {
    rgseaa() {
      let instalacion = this.datos.solicitud.sites.filter(
        (site) => site.tipo == "instalacion"
      );
      let data = instalacion[0].site_data.find(
        (data) => data.keyname == "rgseaa"
      );

      return data.value;
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD/MM/YYYY") : "";
    },
    formatDateLong(date) {
      return date ? this.$moment(date).format("LL") : "";
    },
  },
};
</script>
